import api from "@/api.js";

export default {
  state: {
    aGGridActionMenu: false,
    selectedRowData: {}
  },
  mutations: {
    setAGGridActionMenu(state, payload) {
      state.aGGridActionMenu = payload;
    },
    setSelectedRowData(state, rowData) {
      state.selectedRowData = rowData;
    }
  },
  actions: {
    async setAGGridActionMenuState({ commit, state }, payload) {
      commit("setAGGridActionMenu", !state.aGGridActionMenu);
      commit("setSelectedRowData", payload);
    },
    setSelectedRowData({ commit }, payload) {
      commit("setSelectedRowData", payload);
    }
  },
  getters: {
    aGGridActionMenu(state) {
      return state.aGGridActionMenu;
    },
    selectedRowData(state) {
      return state.selectedRowData;
    }
  }
};
